<template >
  <v-app style='background-color: #f8f8f8;'>

    <div id="app_top">
      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-y-auto base_back"
        :src="iaas_logo"
        style="padding-top: 0px;"
        >
      <v-container class="max_width" fluid
      >
        <header-for-page></header-for-page>

        <router-view/>

        <foother-for-page></foother-for-page>
      </v-container>

    </v-sheet>
  </div>


  </v-app>
</template>

<script>
  import HeaderForPage from './components/Common/HeaderForPage.vue'
  import FootherForPage from './components/Common/FootherForPage.vue'
  import iaas_logo from '../src/assets/IAAS_back_logo.png';


  export default {
    name: 'App',
    components: {
      HeaderForPage,
      FootherForPage,
    },

    data() {
      return {
        iaas_logo,
      }
    },
  };

</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300..900;1,300..900&display=swap');
  
  $body-font-family: 'Rubik';
  $title-font: 'Rubik'; 

  p{
    font-family: $body-font-family, sans-serif !important;
    word-break: break-word !important;
  }

  .v-application {
    font-family: $body-font-family, sans-serif !important;
    .title {
        font-family: $title-font, sans-serif !important;
    }
  }

  .foot-label{
    color: #adadad;
    cursor: default;
    margin-bottom: 0px !important;
  }
  .foot-text{
    color: #010108;
    margin-bottom: 0px !important;
    cursor: default;
  }

  .foot-line{
    line-height: 1.1rem !important;
    padding-top: 8px !important;
  }

  .no-uppercase {
     text-transform: unset !important;
  }

  .max_width {
    max-width: 1264px;
  }

  .text_color{
    color: #010108;
  }
  .text-color-blue{
    color: #1731C2 !important;
  }

  .base_back {
    background: url('../src/assets/IAAS_back_logo.png');
    background-size: cover;
    height: 100vh;
  }

  .page-title{
    font-weight: 700 !important;
    font-size: 32px !important;
  }
  .page-title-padding{
    padding-left: 72px !important;
  }

</style>
